import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import browserHelper from '@utils/browser-helper';
import { CordovaPluginsService } from './services/cordova-plugins.service.abstract';
import { NoopCordovaPluginsService } from './services/noop-cordova-plugins.service';
import { RealCordovaPluginsService } from './services/real-cordova-plugins.service';

@NgModule({
  imports: [CommonModule],
  providers: [
    {
      provide: CordovaPluginsService,
      useClass: browserHelper.isInWrapper ? RealCordovaPluginsService : NoopCordovaPluginsService
    }
  ]
})
export class CordovaModule {}
